import React, {useState} from 'react';
import styled from 'styled-components';
import Search from '../../../BaseComponentWrappers/MotifSearch';
import {labels} from '../../../../../util/utils';

export default function MultiEntityListSearch(props) {
	const {onSearch, onClear, initialText} = props;
	const [searchText, setSearchText] = useState(initialText || '');

	const onChangeSearchText = (event) => {
		setSearchText(event.target.value);
	};
	const onSearchEnter = () => {
		onSearch(searchText);
	};
	const onSearchClear = () => {
		setSearchText('');
		onClear();
	};

	return (
		<StyledMultiEntityListSearch className="StyledMultiEntityListSearch">
			<Search
				id="searchMultiEntity"
				// styleName="relatedDocSearch"
				value={searchText}
				onChange={onChangeSearchText}
				placeholder={labels.placeholderForSearch}
				onSearchButtonClick={onSearch}
				onEnter={onSearchEnter}
				onClear={onSearchClear}
				styleName={'MultiEntitySearch'}
			/>
		</StyledMultiEntityListSearch>
	);
}

const StyledMultiEntityListSearch = styled.section`
	display: flex;
	margin-bottom: var(--px-32);
	.MultiEntitySearch {
		width: var(--px-350);
	}
`;
